import styled from "styled-components";
import { colorData } from "../../data";

export const SkillBlock = styled.div`
    width: 100%; 
    margin-bottom: 16px;
    border: 1px solid ${colorData.gray};
`

export const SkillBlockName = styled.div`
    font-weight: 600;
    padding: 8px;
    border-bottom: 1px solid ${colorData.gray};
`

export const SkillBlockList = styled.ul`
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    justify-content: start;
    align-items: start;
    color: ${colorData.gray};
`

export const SkillsBlockListItem = styled.li`

`